import styles from "./ImageDetail.module.css";

const PropertiesBottomSection = ({ details }) => (
  <div className="container-fluid p-3">
    <div className="row">
      <div className="col-4">
        <div className={styles.bottomSectionPropertiesSingle}>
          <span>Character</span> {details ? details.properties[0] : ""}
        </div>
      </div>
      <div className="col-4">
        <div className={styles.bottomSectionPropertiesSingle}>
          <span>Character</span> {details ? details.properties[1] : ""}
        </div>
      </div>
      <div className="col-4">
        <div className={styles.bottomSectionPropertiesSingle}>
          <span>Character</span> {details ? details.properties[2] : ""}
        </div>
      </div>
    </div>
  </div>
);

export default PropertiesBottomSection;
